
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { status, statusDetail } from "interface";

interface DashboardState {
  userId: string;
  token: string | null;
  userState: status;
  userStateDetail: statusDetail;
}

const initialState: DashboardState = {
  token: null,
  userId: "",
  userState: "REGISTER",
  userStateDetail: "NOT_CHECKED",
};
export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setUserID: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    setUserState: (state, action: PayloadAction<status>) => {
      state.userState = action.payload;
    },
    setUserStateDetail: (state, action: PayloadAction<statusDetail>) => {
      state.userStateDetail = action.payload;
    },
  },
});
export const { setUserID, setToken, setUserState, setUserStateDetail } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
